import { Flex } from '@mprolab/uikit'
import styled from 'styled-components'

export const LoadingPlaceholder = styled(Flex)<{ width: string; height?: string }>`
  width: ${({ width }) => width}px;
  background: ${({ theme }) => theme.colors.gray7};
  height: ${({ height }) => height || '17px'};
  border-radius: 8px;
  animation: opacity infinite 1.5s linear;
  @keyframes opacity {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
`
